/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurfaceBlockLayout
 */
export interface SurfaceBlockLayout {
    /**
     * 
     * @type {number}
     * @memberof SurfaceBlockLayout
     */
    columns?: SurfaceBlockLayoutColumnsEnum;
    /**
     * 
     * @type {string}
     * @memberof SurfaceBlockLayout
     */
    columnSplit?: SurfaceBlockLayoutColumnSplitEnum;
    /**
     * 
     * @type {boolean}
     * @memberof SurfaceBlockLayout
     */
    stackOnMobile?: boolean;
}


/**
 * @export
 */
export const SurfaceBlockLayoutColumnsEnum = {
    NUMBER_1: 1,
    NUMBER_2: 2,
    NUMBER_3: 3
} as const;
export type SurfaceBlockLayoutColumnsEnum = typeof SurfaceBlockLayoutColumnsEnum[keyof typeof SurfaceBlockLayoutColumnsEnum];

/**
 * @export
 */
export const SurfaceBlockLayoutColumnSplitEnum = {
    _5050: '50-50',
    _6040: '60-40',
    _7030: '70-30',
    _4060: '40-60',
    _3070: '30-70'
} as const;
export type SurfaceBlockLayoutColumnSplitEnum = typeof SurfaceBlockLayoutColumnSplitEnum[keyof typeof SurfaceBlockLayoutColumnSplitEnum];


/**
 * Check if a given object implements the SurfaceBlockLayout interface.
 */
export function instanceOfSurfaceBlockLayout(value: object): value is SurfaceBlockLayout {
    return true;
}

export function SurfaceBlockLayoutFromJSON(json: any): SurfaceBlockLayout {
    return SurfaceBlockLayoutFromJSONTyped(json, false);
}

export function SurfaceBlockLayoutFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurfaceBlockLayout {
    if (json == null) {
        return json;
    }
    return {
        
        'columns': json['columns'] == null ? undefined : json['columns'],
        'columnSplit': json['columnSplit'] == null ? undefined : json['columnSplit'],
        'stackOnMobile': json['stackOnMobile'] == null ? undefined : json['stackOnMobile'],
    };
}

export function SurfaceBlockLayoutToJSON(json: any): SurfaceBlockLayout {
    return SurfaceBlockLayoutToJSONTyped(json, false);
}

export function SurfaceBlockLayoutToJSONTyped(value?: SurfaceBlockLayout | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'columns': value['columns'],
        'columnSplit': value['columnSplit'],
        'stackOnMobile': value['stackOnMobile'],
    };
}

